(function() {
    'use strict';
    
a3_cabin_reports.controller('MandatoryModalCtrl', MandatoryModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name MandatoryModalCtrl
    * @description 
    * Warning Modal about unread mandatory memos
    * @ngInject
    */
function MandatoryModalCtrl($scope, mandatoryUnread, MemoFactory, $uibModal, $routeParams, $location, $uibModalInstance) {
        $scope.mandatoryUnread = mandatoryUnread;
        $scope.gotoMandatoryUnreadMemos = gotoMandatoryUnreadMemos;

        function gotoMandatoryUnreadMemos(){
            $location.path('/memos/unreadMandatory');
            cancel();
        }
          
        /**
        * Closes modal
        * @memberof ProposalInfoModalCtr
        */
        function cancel() {
            $uibModalInstance.close('cancel');
        }
    }

    
})();